export default __webpack_public_path__ + "b84257f3c63cf8fdb2bbbd6c180e4554.png";